import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackbarService } from '../../../rds-utilities/snackbar.service';
import { DatabaseGwService } from '../../../rds-objects/services/database-gw.service';

@Component({
	selector: 'rds-select-recordtype',
	templateUrl: './select-recordtype.component.html',
	styleUrls: ['./select-recordtype.component.scss']
})
export class SelectRecordtypeComponent implements OnInit {

	isLoading: boolean = true;
	listRecordTypes: any = [];

	@Input() title: string = "Select Record Type";
	@Input() targetlink: string = '';
	@Input() tableName: string = '';
	@Input() apiRoute:string = '/error-object';
	@Input() isSelector:boolean = false;
	@Input() isPopUp:boolean = false;

	@ViewChild("template", { static: false }) template: TemplateRef<any>;

	constructor(
		private router: Router,
		private $dataBase: DatabaseGwService,
		private $snackBarService: SnackbarService,
		private dialog: MatDialog,
	) { }

	ngOnInit() { 

		this.isLoading = true;
		let filter: any = {
			object_name: this.tableName
		};
		this.$dataBase.query(filter, this.apiRoute).subscribe(res => {
			this.listRecordTypes = res.data;
			this.listRecordTypes && this.listRecordTypes.length ? this.openPopup() : this.goToTargetRoute();
			this.isLoading = false;
		}, err => {
			this.$snackBarService.error(err.message);
			this.isLoading = false;
		});
	}

	//open popup
	openPopup() {
		this.dialog.open(this.template, { panelClass: 'full-width-dialog-sm-padding', width: '30vw' });
	}

	//target route if there is no record type to choose
	goToTargetRoute() {
		this.router.navigate([this.targetlink]);
	}

	//close popup
	onClose() {
		this.dialog.closeAll();
	}
}
